import CameraControls from "camera-controls";

import { Context } from "../../../context";
import { ControllerStrategy } from "../strategy";

export class ZoomFOVControllerStrategy extends ControllerStrategy {
  minZoom = -Infinity;
  maxZoom = Infinity;

  defaultZoom = 1;

  private prevMode?: "dolly" | "fov";

  init(context: Context): ControllerStrategy {
    super.init(context);

    if (!this.registered) return this;

    const { controls } = this.registered;

    if (controls) {
      this.prevMode =
        controls.touches.two == CameraControls.ACTION.TOUCH_ZOOM_TRUCK
          ? "fov"
          : "dolly";

      this.maxZoom = this.registered.state.zoomConfig.fov.max;
      this.minZoom = this.registered.state.zoomConfig.fov.min;

      controls.maxZoom = this.maxZoom;
      controls.minZoom = this.minZoom;

      controls.dollySpeed = this.registered.state.zoomConfig.fov.speed;

      controls.mouseButtons.wheel = CameraControls.ACTION.ZOOM;
      controls.touches.two = CameraControls.ACTION.TOUCH_ZOOM_TRUCK;
    }

    // TODO: do we want to assume 1 or get the zoom from the camera?
    // if (camera) {
    //   this.defaultZoom = camera.zoom;
    // }

    return this;
  }

  teardown() {
    super.teardown();

    const controls = this.registered?.controls;
    if (controls) {
      controls.minZoom = 0.01;
      controls.maxZoom = Infinity;

      controls.zoomTo(this.defaultZoom, true);

      controls.dollySpeed = 1;

      if (this.prevMode == "dolly") {
        controls.mouseButtons.wheel = CameraControls.ACTION.DOLLY;
        controls.touches.two = CameraControls.ACTION.TOUCH_DOLLY_TRUCK;
      }
    }
  }
}
